import { post } from "../utils";

export default host => {
  /**
   * @param {RequestData} data
   */
  const request = data => {
    const form = new FormData();

    if(data.photoIds) data.photoIds.forEach(photoId => form.append(`image_file_ids[]`, photoId));
    form.append(`client_id`, data.clientId);

    return post(`${host}/user/associate-person`, form);
  };
  return request;
};